<template>
    <v-card>
        <v-toolbar color="primary" dark>
            <v-spacer></v-spacer>
            <v-toolbar-title>Dados da negociação</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div>
            <h1 class="text-xs-center primary--text" style="width: 100%">{{proposta.empresa.nome_fantasia}}</h1>
            <v-flex xs12 class="text-xs-center pb-2 pt-2 mb-3"><b>{{proposta.empresa.razao_social}}</b></v-flex>
            <v-flex xs12 class="text-xs-left pb-2 pt-2">CNPJ: <b>{{proposta.empresa.cnpj}}</b></v-flex>
          </div>
          <v-layout row wrap justify-space-around fill-height>
            <v-flex xs12 class="text-xs-left pb-2">Email: <b>{{proposta.empresa.administrador.email}}</b></v-flex>
            <v-flex xs12 class="text-xs-left pb-2">Telefone: <b>{{proposta.empresa.administrador.telefone}}</b></v-flex>
            <v-flex xs12 class="text-xs-left pb-2">
              Para:
              <b>
                <template v-if="proposta && proposta.combustivel">
                  {{proposta.combustivel.nome}}
                </template>
                <template v-else-if="proposta && proposta.item">
                  {{proposta.item.nome}}
                </template>
                <template v-else>
                  Todos os Combustíveis
                </template>
              </b>
            </v-flex>
            <v-flex xs12 class="mt-3">
              <v-select
                v-model="forma_pagamento"
                :items="[
                  { text: 'Pagamento antecipado (pré-pago)', value: 'prepago' },
                  { text: 'Pagamento futuro (pós-pago)', value: 'pospago' },
                  { text: 'Pagamento no posto (presencial)', value: 'presencial' },
                ]"
                label="Forma de pagamento"
                item-text="text"
                item-value="value"
                :disabled="!!proposta.modelo_faturamento"
              />
            </v-flex>
            <template v-if="resposta === null">
              <v-btn v-if="proposta.status === null" round @click="rejeitarProposta" color="error">Rejeitar Proposta</v-btn>
              <v-btn v-if="proposta.status === null" round @click="resposta = true" color="info">Aceitar Proposta</v-btn>
            </template>
            <template v-else-if="resposta === true">
              <v-flex xs12 v-if="forma_pagamento === 'pospago'" class="mt-2">
                <v-text-field
                  label="Insira o valor do crédito"
                  v-money="money"
                  v-model.lazy="valor_inicial_money"
                  prefix="R$"
                  ref="valor_inicial_money"
                />
              </v-flex>
              <v-flex xs12 v-if="forma_pagamento === 'prepago'" class="mt-2">
                <h4 class="text-xs-center">Acréscimo</h4>
                <v-text-field
                  ref="desconto"
                  label="Porcentagem do acréscimo"
                  type="number"
                  suffix="%"
                  v-model="desconto"
                   :rules="[
                      v => !!v || 'Valor Inválido',
                      v => verificar(v) || 'Não é permitido números reais'
                    ]"
                />
              </v-flex>
              <v-flex xs12 v-if="forma_pagamento === 'presencial'" class="mt-2">
                <h4 class="text-xs-center">Desconto</h4>
                <v-text-field
                  ref="desconto"
                  label="Porcentagem do desconto"
                  type="number"
                  suffix="%"
                  v-model="desconto"
                  :rules="[
                      v => !!v || 'Valor Inválido',
                      v => verificar(v) || 'Não é permitido números reais'
                    ]"
                />
              </v-flex>
              <v-layout row v-if="forma_pagamento === 'pospago'" class="mt-2">
                <v-layout row>
                  <v-flex xs6 class="mr-1">
                  <v-text-field
                      ref="desconto"
                      label="Porcentagem do desconto"
                      v-model="desconto"
                      suffix="%"
                      type="number"
                      :rules="[
                        v => !!v || 'Valor Inválido',
                        v => verificar(v) || 'Não é permitido números reais'
                      ]"
                    />
                  </v-flex>
                  <v-flex xs6 class="ml-1">
                    <v-select
                      ref="selectRef"
                      label="Cobrança"
                      :items="items"
                      item-text="title"
                      item-value="value"
                      v-model="selectOpcoes"
                      :disabled="selectOpcoes !== null"
                    />
                  </v-flex>
                </v-layout>
              </v-layout>
              <v-flex xs12 v-if="forma_pagamento === 'pospago'">
                  <h5 class="text-xs-center">Total de crédito {{valor_total | currency({fractionCount: 2})}}</h5>
              </v-flex>
            </template>
              </v-layout>
        </v-card-text>
        <v-card-actions>
            <v-btn flat color="primary" @click="$emit('fechar')">Voltar</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              v-if="resposta === true"
              flat
              color="primary"
              @click="submeterProposta()"
              :disabled="forma_pagamento == null || forma_pagamento == 'pospago' && selectOpcoes == null || desconto < 0 || desconto > 100"
            >
              Submeter
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>

import { propostasDao } from '@/api'
import { VMoney } from 'v-money'

export default {
  directives: { money: VMoney },
  props: ['proposta'],
  data () {
    return {
      infoPosto: {
        endereco: {},
        representante: {}
      },
      resposta: null,
      items: [
        { title: 'Semanal', value: 0 },
        { title: 'Quinzenal', value: 1 },
        { title: 'Mensal', value: 2 }
      ],
      selectOpcoes: null,
      desconto: 0,
      credito: false,
      pospago: false,
      prazo: null,
      forma_pagamento: '',
      valor_inicial_money: 0,
      valor_inicial: 0,
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: false
      }
    }
  },
  computed: {
    headers () {
      return this.$store.getters.headers
    },
    posto () {
      return this.$store.getters.posto
    },
    valor_total () {
      if (this.desconto <= 0 || this.proposta.modelo_faturamento !== 'prepago') {
        return this.valor_inicial
      }
      const des = this.desconto / 100
      return this.valor_inicial + (this.valor_inicial * des)
    }
  },
  watch: {
    valor_inicial_money (val) {
      let val1 = val.split(',')
      val = Number(`${val1[0].split('.').join('')}.${val1[1]}`)
      if (val) {
        this.valor_inicial = val
      }
    }
  },
  methods: {
    verificar (v) {
      if (!v) return false
      if (v === null) return false
      if (v.toString().search(/[.]/g) !== -1) {
        return false
      }
      return true
    },
    rejeitarProposta () {
      this.$store.dispatch('rejeitarProposta', { id: this.proposta.id }).then(() => {
        this.$emit('fechar')
      })
    },
    submeterProposta () {
      this.proposta.periodo = this.selectOpcoes
      this.proposta.desconto = this.desconto
      this.proposta.valor_inicial = this.valor_inicial
      this.proposta.modelo_faturamento = this.forma_pagamento
      this.proposta.posto = this.posto.cnpj
      propostasDao.submeterProposta(this.proposta, this.headers).then(response => {
        if (response.ok) {
          this.$emit('carregar')
          this.$emit('fechar')
        } else {
          console.log('Error')
        }
      })
    },
    clearInput () {
      this.$refs.desconto_ref.clearableCallback()
      this.$refs.selectRef.clearableCallback()
      this.$refs.prazoRef.clearableCallback()
      this.$refs.valor_inicial_money.clearableCallback()
      this.$refs.check_pos.reset()
      this.$refs.check_pre.reset()
    }
  },
  beforeMount () {
    if (this.proposta) {
      this.forma_pagamento = this.proposta.modelo_faturamento
      this.selectOpcoes = this.proposta.periodo
    }
  }
}
</script>
